import * as layout from "../../routes/$layout.js";

const components = [
	() => import("../../routes/index.js"),
	() => import("../../routes/online-service.js"),
	() => import("../../routes/privacy-policy.js"),
	() => import("../../routes/inspection.js"),
	() => import("../../routes/contact.js"),
	() => import("../../routes/recruit.js"),
	() => import("../../routes/rental.js"),
	() => import("../../routes/about.js"),
	() => import("../../routes/stock/index.js"),
	() => import("../../routes/stock/[id].js"),
	() => import("../../routes/news/index.js"),
	() => import("../../routes/news/[id].js")
];

export const pages = (d => [
	{
		// index.svelte
		pattern: /^\/$/,
		parts: [
			[components[0]]
		]
	},

	{
		// online-service.svelte
		pattern: /^\/online-service\/?$/,
		parts: [
			[components[1]]
		]
	},

	{
		// privacy-policy.svelte
		pattern: /^\/privacy-policy\/?$/,
		parts: [
			[components[2]]
		]
	},

	{
		// inspection.svelte
		pattern: /^\/inspection\/?$/,
		parts: [
			[components[3]]
		]
	},

	{
		// contact.svelte
		pattern: /^\/contact\/?$/,
		parts: [
			[components[4]]
		]
	},

	{
		// recruit.svelte
		pattern: /^\/recruit\/?$/,
		parts: [
			[components[5]]
		]
	},

	{
		// rental.svelte
		pattern: /^\/rental\/?$/,
		parts: [
			[components[6]]
		]
	},

	{
		// about.svelte
		pattern: /^\/about\/?$/,
		parts: [
			[components[7]]
		]
	},

	{
		// stock/index.svelte
		pattern: /^\/stock\/?$/,
		parts: [
			[components[8]]
		]
	},

	{
		// stock/[id].svelte
		pattern: /^\/stock\/([^/]+?)\/?$/,
		parts: [
			[components[9], m => ({ id: d(m[1]) })]
		]
	},

	{
		// news/index.svelte
		pattern: /^\/news\/?$/,
		parts: [
			[components[10]]
		]
	},

	{
		// news/[id].svelte
		pattern: /^\/news\/([^/]+?)\/?$/,
		parts: [
			[components[11], m => ({ id: d(m[1]) })]
		]
	}
])(decodeURIComponent);

export const ignore = [
	/^\/preload\/?$/,
	/^\/query\/?$/,
	/^\/stock\/preload\/?$/,
	/^\/stock\/query\/?$/,
	/^\/news\/preload\/?$/,
	/^\/news\/query\/?$/
];

export { layout };